import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, setCurrentWizardStep } from './wizard-step.actions';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(setCurrentWizardStep, (_state, action) => {
    return action.wizardStep;
}), on(resetAllCustomPdfReportItems, () => {
    return 0;
}));
